<template>
  <div v-if='isShowIcon'>
    <el-image v-if='isImage' :src='iconPath'></el-image>
    <i v-else class='iconfont zmr_icon_i' :class='iconPath'></i>
  </div>
</template>

<script setup>
import { ElImage } from 'element-plus'
import { ref, computed } from 'vue'
import { isNotEmpty } from '../../common/js/comjs.js'

const props = defineProps(['name'])
const iconPath = ref('')
const isShowIcon = ref(false)
const isImage = ref(false)
const propName = computed(() => {
  return props.name
})
if (isNotEmpty(propName.value)) {
  isImage.value = false

  if (propName.value.indexOf('icon-') < 0) {
    iconPath.value = 'icon-' + propName.value
  } else {
    iconPath.value = propName.value
  }


  isShowIcon.value = true
}

</script>

<style scoped>

</style>
